import React, { useMemo } from 'react';

// material-ui
import { Typography } from '@mui/material';

// project imports
import NavGroup from './NavGroup';
import menuItem from 'menu-items';
import JSDB from '../../../../fromKotlin/nk';

// ==============================|| SIDEBAR MENU LIST ||============================== //

const MenuList = () => {
    const canShowDashboard = JSDB().curUser?.show_dashboard == 1;

    const navItems = useMemo(() => menuItem.items.map((item) => {
        if (item.type === 'group') {
            let children = (item as any).children;
            if (item.id === 'application' && Array.isArray(children)) {
                children = children.filter(
                    (c: any) => (c.id !== 'dashboard' && c.id !== 'anomalies') || canShowDashboard
                );
            }
            return <NavGroup key={item.id} item={{ ...item, children }} />;
        }
        return (
            <Typography key={item.id} variant="h6" color="error" align="center">
                Menu Items Error
            </Typography>
        );
    }), [canShowDashboard]);

    return <>{navItems}</>;
};

export default React.memo(MenuList);
